import api from './axiosConfig';

export const transactionApi = {
  addTransaction: (data) => api.post('/v1/transactions', data),
  getAllTransactions: () => api.get('/v1/transactions'),
  getLedger: (customerId) => api.get(`/v1/transactions/ledger/${customerId}`),
  getTransactionDetails: (id) => api.get(`/v1/transactions/${id}`),
  editTransaction: (id, data) => api.put(`/v1/transactions/${id}`, data),
  downloadPdf: (customerId) => api.get(`/v1/reports/customer/${customerId}/pdf`, { responseType: 'blob' }),
};
